import React from 'react';
import ModalComponent from '../../../../../../../../components/modal/index';
import FieldComponent from '../../../../../../../../components/field/index';
import movements from '../../../../../../../../services/movements/index';
import { startOfDay } from 'date-fns';
import appointments from '../../../../../../../../services/appointments/index';
import users from '../../../../../../../../services/users';
import patients from '../../../../../../../../services/patients/index';

export default class EditPatientModal extends React.Component {
    state = {
        name: "",
        lastname: "",
        phone: "",
        errors: {
            name: "",
            lastname: "",
            phone: ""
        },
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.isActive) {
            return {
                name: nextProps.patient.name,
                lastname: nextProps.patient.lastname,
                phone: nextProps.patient.phone,
                errors: {
                    name: "",
                    lastname: "",
                    phone: ""
                },
            }
        }
        return null
    }

    onInputChange = (e) => {
        let {value, name} = e.target;
        let newState = Object.assign({}, this.state);
        newState[name] = value
        newState.errors[name] = ""
        this.setState(newState)
    }

    submit = (e) => {
        e.preventDefault();
        let hasError = false;
        let errors = Object.assign({}, this.state.errors)

        if(!this.state.name){
            errors.name = "Agregue el nombre porfavor."
            hasError = true;
        }

        if(!this.state.lastname){
            errors.lastname = "Introduzca el apellido porfavor."
            hasError = true;
        }
        this.setState({errors: errors})

        if(!hasError) {
            patients.update({_id: this.props.patient._id}, {
                name: this.state.name,
                lastname: this.state.lastname,
                phone: this.state.phone
            }, {}, (error) => {
                this.props.close();
                this.props.setPatient({
                    name: this.state.name,
                    lastname: this.state.lastname,
                    phone: this.state.phone
                })
            })
        }
    }

    render() {
        return (
            <ModalComponent {...this.props} hasClose={true}>
                <div className="modal-card">
                    <header className="modal-card-head">
                    <p className="modal-card-title">
                        Editar paciente
                    </p>
                    </header>
                    <section className="modal-card-body">
                        <form id="form"
                            onSubmit={this.submit}
                        >
                            <FieldComponent label="Nombre *"
                                value={this.state.name}
                                error={this.state.errors.name}
                                name="name" onInputChange={this.onInputChange} icon="user"
                            />
                            <FieldComponent label="Apellido *"
                                value={this.state.lastname}
                                error={this.state.errors.lastname}
                                name="lastname" onInputChange={this.onInputChange} icon="user"
                            />
                            <FieldComponent label="Teléfono"
                                value={this.state.phone}
                                error={this.state.errors.phone}
                                name="phone" onInputChange={this.onInputChange} icon="phone"
                            />
                        </form>
                    </section>
                    <footer className="modal-card-foot">
                        <button form="form" className="button is-primary" type="submit">
                            Guardar
                        </button>
                    </footer>
                </div>
            </ModalComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/components/edit-patient-modal/index.js